import api from "@services/axios/apiManager";
import type { TrackingSession } from "./trackingSession";

/**
 * 要一張配送追蹤通行證。
 * 不在配送中時後端回 200 { available: false }（不是 4xx），避免每張單結束都進 Sentry。
 */
export async function fetchTrackingSession(
  orderId: string,
  headers: Record<string, string>,
): Promise<TrackingSession> {
  const res = await api.post(`/app-api/platform-orders/${orderId}/tracking-session`, undefined, { headers });
  const data = res?.data?.data as TrackingSession | undefined;
  if (!data || typeof data.available !== "boolean") {
    throw new Error("tracking-session 回應格式不正確");
  }
  return data;
}
